import './App.css'
import * as React from 'react'
import { Route, Routes } from 'react-router-dom'
import Success from './Invite/components/Success'
import '@mantine/core/styles.css'
import QueryReport from './QueryReport'
import Report from './Report'
import Invite from './Invite'
import Orders from './Orders'
import Login from './Login'
import Sample from './Sample'
import Payment from './Payment'
import Faceid from './Faceid'
import Lottery from './Lottery'
import MerchantLogin from './MerchantLogin'
import Complaint from './Complaint'
import NotFound from './NotFound'
import Home from './Home'
import MerchantApply from './MerchantApply'
import MerchantApplyCallback from './MerchantApplyCallback'
import MerchantComplete from './MerchantComplete'
import MerchantCompleteCallback from './MerchantCompleteCallback'

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/queryReport" element={<QueryReport />} />
      <Route path="/reports/:orderId" element={<Report />} />
      <Route path="/reportSamples/:templateId" element={<Sample />} />
      <Route path="/success" element={<Success />} />
      <Route path="/invite" element={<Invite />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/example" element={<Report />} />
      <Route path="/login" element={<Login />} />
      <Route path="/merchantLogin" element={<MerchantLogin />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/faceid" element={<Faceid />} />
      <Route path="/lottery" element={<Lottery />} />
      <Route path="/complains" element={<Complaint />} />
      <Route path="/merchantApply" element={<MerchantApply />} />
      <Route path="/merchantApplyCallback" element={<MerchantApplyCallback />} />
      <Route path="/merchantComplete" element={<MerchantComplete />} />
      <Route path="/merchantCompleteCallback" element={<MerchantCompleteCallback />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default App
